// WM (white-matter) polygon utilities. Coordinates are in OME-Zarr L0 pixels.

export type Ring = Array<[number, number]>;

export function pointInPoly(px: number, py: number, ring: Ring): boolean {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    const intersect = ((yi > py) !== (yj > py)) &&
      (px < ((xj - xi) * (py - yi)) / (yj - yi + 1e-12) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

export function rectInWm(
    x: number, y: number, w: number, h: number, rings: Ring[]
): number {
  if (!rings || !rings.length) return 0;
  const N = 25;
  let inside = 0, total = 0;
  for (let i = 0; i < N; i++) {
    for (let j = 0; j < N; j++) {
      const px = x + (w * i) / (N - 1);
      const py = y + (h * j) / (N - 1);
      total++;
      for (const ring of rings) {
        if (pointInPoly(px, py, ring)) { inside++; break; }
      }
    }
  }
  return inside / total;
}

// Constrain-mode acceptance gate (legacy behaviour) and the "fully inside"
// cutoff. rectInWm samples a 25x25 grid, so overlap == 1.0 means every grid
// point landed in the WM polygon; 0.999 absorbs float noise.
export const WM_GATE = 0.80;
export const WM_FULL_MIN = 0.999;

export type WmClass = "full" | "partial" | "outside";

// Segment a pick by WM containment from its overlap fraction alone (single
// source of truth — no stored flag). "full" = rect entirely within WM.
export function wmClass(overlap: number | null | undefined): WmClass {
  if (overlap == null) return "outside";
  if (overlap >= WM_FULL_MIN) return "full";
  if (overlap > 0) return "partial";
  return "outside";
}

export function hexToRgb(h: string): [number, number, number] {
  const s = h.replace("#", "");
  return [parseInt(s.slice(0, 2), 16), parseInt(s.slice(2, 4), 16), parseInt(s.slice(4, 6), 16)];
}
